import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import UsersForm from "../users/UserForm";
import { useSelector } from "react-redux";

function Settings() {
  const authUser = useSelector((state) => state.auth);

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <UsersForm userId={authUser.user.id} />
      </div>
    </Base>
  );
}

export default Settings;
